import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { IHotel } from '../../../store/hotel/interface';
import home_icon from '../../../assets/home_icon.svg';
import bed_icon from '../../../assets/bed_icon.svg';
import start_icon from '../../../assets/start_icon.svg';
import location_icon from '../../../assets/location_icon.svg';
import people_icon from '../../../assets/people_icon.svg';
import {
  AddBtn,
  Card,
  Container,
  Header,
  HotelImage,
  HotelName,
  HeaderDetailContainer,
  DetailsContainer,
  HotelLocation,
  HeaderIcon,
  Row,
  Title,
  IconRow,
  SectionHeader,
  SectionDetails,
  RoomTypeContainer,
  EmptyState,
  EmptyTxt,
  CustomAgentCard,
  EditBtn
} from './style';
import { IconGroup } from '../allHotel/component/hotelListCard';
import { RoomType } from './roomType';
import { AddRoom } from '../modal/addRoom';
import { useGetHotelByIdQuery } from '../../../store/hotel/api';
import { Loader } from '../../../component/loader';
import { EditHotel } from '../modal/editHotel';

export const ViewHotel = () => {
  const { state } = useLocation();
  const [hotelId] = useState((state as { hotelId: string }).hotelId);
  const [hotel, setHotel] = useState<IHotel>();
  const [showAddRoom, setShowAddRoom] = useState(false);
  const { data: hotelData, isLoading } = useGetHotelByIdQuery(hotelId);
  const [editHotelModal, setEditHotelModal] = useState(false);
  const handleEditHotel = () => {
    setEditHotelModal(true);
  };
  useEffect(() => {
    if (hotelData) {
      setHotel(hotelData.data);
    }
  }, [hotelData]);

  return (
    <Container>
      {editHotelModal && hotel && (
        <EditHotel setShow={setEditHotelModal} hotelItems={hotel} />
      )}
      <Header>
        <Title>Hotel</Title>
        <Row>
          <AddBtn onClick={() => setShowAddRoom(true)}>Add room</AddBtn>
          <EditBtn onClick={() => handleEditHotel()}>Edit Hotel</EditBtn>
        </Row>
      </Header>
      {isLoading && <Loader />}
      {showAddRoom && (
        <AddRoom hotelID={hotel?._id ?? ''} setShow={setShowAddRoom} />
      )}
      <Row>
        <Card>
          <HotelImage images={hotel?.file ?? []} />
          <DetailsContainer>
            <HotelName>{hotel?.name ?? ''}</HotelName>
            <Row>
              <HeaderDetailContainer>
                <HeaderIcon src={location_icon} />
                <HotelLocation>{`${
                  hotel?.location.state ?? ''
                }, Nigeria`}</HotelLocation>
              </HeaderDetailContainer>
              <HeaderDetailContainer>
                <HeaderIcon src={people_icon} />
                <HotelLocation>{`${
                  hotel?.totalBookingForTheMonth ?? ''
                } bookings`}</HotelLocation>
              </HeaderDetailContainer>
            </Row>
            <IconRow>
              <IconGroup
                icon={home_icon}
                text={`${hotel?.type.replace('-', ' ') ?? ''}`}
              />
              <IconGroup
                icon={start_icon}
                text={`${hotel?.rating ?? ''} star`}
              />
              <IconGroup
                icon={bed_icon}
                text={`${hotel?.noOfRooms ?? ''} rooms`}
              />
            </IconRow>
            <SectionHeader>Address</SectionHeader>
            <SectionDetails>{hotel?.location.address ?? ''}</SectionDetails>
            <SectionHeader>Facilities</SectionHeader>
            <ul>
              {hotel?.facilitiesAndServices.map((item, index) => (
                <SectionDetails as={'li'} key={index.toString()}>
                  {item}
                </SectionDetails>
              ))}
            </ul>
            <SectionHeader>Room types</SectionHeader>
            {!hotel?.rooms.length ? (
              <EmptyState>
                <EmptyTxt>
                  No room types, click on the button below to add room type
                </EmptyTxt>
                <AddBtn onClick={() => setShowAddRoom(true)}>
                  Add room type
                </AddBtn>
              </EmptyState>
            ) : (
              <RoomTypeContainer>
                {hotel?.rooms.map((room, index) => (
                  <RoomType
                    room={room}
                    hotelName={hotel.name}
                    key={index.toString()}
                  />
                ))}
              </RoomTypeContainer>
            )}

            <SectionHeader>Description</SectionHeader>
            <SectionDetails>{hotel?.description}</SectionDetails>
          </DetailsContainer>
        </Card>
        {hotel?.agent && <CustomAgentCard hideDelete agent={hotel.agent} />}
      </Row>
    </Container>
  );
};
